import bso from '../../assets/OtherEvents/bso.jpg';
import campus from '../../assets/OtherEvents/campus.webp';

export const otherEventsData = [
  {
    title: 'Black Student Orientation',
    description:
      'Want to celebrate Black culture, embrace the community at the University of Toronto, and prepare yourself for the UofT experience? Black Student Orientation, organized by Black Students for Black students, is an opportunity to make a smooth transition into university life, make new friends, and start the year on a positive note! Registration for this FREE orientation is open!',
    image: bso,
    link: 'https://www.instagram.com/uoftbso/',
  },
  // {
  //   title: 'Faculty Orientation Events',
  //   description:
  //     "Check out the schedule for Faculty Orientation Events happening on August 28th!",
  //   image: campus,
  //   link: 'https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/',
  // },
];
